import * as yup from 'yup';

export const initialValues = {
  busy_mode: 'day',
  time: '01:00',
};

export const validationSchema = yup.object().shape({});
